import React from 'react';
import QRCodeGenerator from './QRCodeGenerator';

const App = () => {
  return (
    <div className="App">
      <QRCodeGenerator />
    </div>
  );
};

export default App;
